"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DarkButton = _interopRequireDefault(require("../../../Button/DarkButton"));

var _Switch = _interopRequireDefault(require("../../../Switch"));

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _consts = require("../consts");

var _styles = require("./styles");

function PollDraftFooterButtons(_ref) {
  var poll = _ref.poll,
      dispatchWithSelectedPollId = _ref.dispatchWithSelectedPollId,
      isClassLive = _ref.isClassLive;
  var options = poll.options;
  var optionsKeys = Object.keys(options);
  var hasEnoughOptions = optionsKeys.filter(function (key) {
    return !!options[key].text;
  }).length > 1;
  var isSaveDisabled = !(hasEnoughOptions || poll.question);
  var isMakeLiveDisabled = !(hasEnoughOptions && poll.question) || !isClassLive;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DarkButton.default, {
    onClick: dispatchWithSelectedPollId(_consts.PollTeacherActions.SAVE_POLL),
    className: "footer-save",
    disabled: isSaveDisabled
  }, "Save Poll"), _react.default.createElement(_DarkButton.default, {
    onClick: dispatchWithSelectedPollId(_consts.PollTeacherActions.MAKE_POLL_LIVE),
    className: "footer-make-live",
    disabled: isMakeLiveDisabled
  }, "Make Live"));
}

function PollFooter(_ref2) {
  var poll = _ref2.poll,
      dispatch = _ref2.dispatch,
      isClassLive = _ref2.isClassLive;

  var dispatchWithSelectedPollId = function dispatchWithSelectedPollId(actionType) {
    return function () {
      dispatch({
        type: actionType,
        payload: {
          pollId: poll.pollId
        }
      });
    };
  };

  var setShowLearners = function setShowLearners(event) {
    dispatch({
      type: _consts.PollTeacherActions.SET_SHOW_LEARNERS,
      payload: {
        pollId: poll.pollId,
        showResults: event.target.checked
      }
    });
  };

  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.pollFooter, 'poll-footer')
  }, _react.default.createElement(_Switch.default, {
    size: "small",
    disabled: poll.status !== _consts.PollStatus.DRAFT,
    checked: poll.showResults,
    onChange: setShowLearners,
    text: _react.default.createElement(_DarkText.default, {
      fontSize: 14
    }, "Show results to Learners"),
    className: "footer-switch"
  }), _react.default.createElement("div", {
    className: "footer-buttons"
  }, poll.status === _consts.PollStatus.DRAFT && _react.default.createElement(PollDraftFooterButtons, {
    poll: poll,
    dispatchWithSelectedPollId: dispatchWithSelectedPollId,
    isClassLive: isClassLive
  }), poll.status === _consts.PollStatus.LIVE && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DarkButton.default, {
    onClick: dispatchWithSelectedPollId(_consts.PollTeacherActions.END_POLL),
    className: "footer-end-poll"
  }, "End Poll"))));
}

var _default = PollFooter;
exports.default = _default;